import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Eyebrow } from "./Motion";

export const PageHero = ({ eyebrow, lines, intro, img, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);

  return (
    <section ref={ref} data-testid={testId} className="mx-auto max-w-7xl px-5 pb-20 pt-36 sm:px-8 lg:pb-28 lg:pt-44">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
        <Eyebrow>{eyebrow}</Eyebrow>
      </motion.div>
      <MaskLines lines={lines} className="font-serif text-5xl font-medium leading-[0.98] tracking-tight text-[#1C1917] sm:text-7xl lg:text-8xl" delay={0.1} />
      <div className="mt-12 grid gap-10 lg:grid-cols-12 lg:items-end">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.6 }}
          className="text-base leading-relaxed text-stone-600 sm:text-lg lg:col-span-5"
        >
          {intro}
        </motion.p>
        {img && (
          <motion.div
            initial={{ clipPath: "inset(100% 0 0 0)" }}
            animate={{ clipPath: "inset(0% 0 0 0)" }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
            className="relative aspect-[16/10] overflow-hidden rounded-sm lg:col-span-6 lg:col-start-7 lg:aspect-[16/9]"
          >
            <motion.img style={{ y }} src={img} alt="" className="absolute inset-0 h-[120%] w-full -translate-y-[10%] object-cover" />
          </motion.div>
        )}
      </div>
    </section>
  );
};
